import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PaginatorModule } from '@primeng/paginator';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { ModalService } from "@shared/services/modal/modal.service";
import { ModalClose } from '@shared/services/modal/modal.enum';
import { BasicForm } from '@shared/components/classes/basic.form';
import { DefaultService } from '@common/references/default.service';
import { NgIf } from '@angular/common';
import { RentersService } from '@modules/universal-billing/renters/renters.service';
import { RentersFormComponent } from '@modules/universal-billing/renters/renters-form/renters-form.component';
import { ApiService } from '@shared/services/api.service';
import { Property } from '@modules/universal-billing/properties/properties.interface';
import { UsersService } from '@modules/settings/users/users.service';
import { User } from '@modules/settings/users/users.interfaces';
import { FullNamePipe } from '@common/pipe/full-name.pipe';

@Component({
  selector: 'app-object-resposible',
  standalone: true,
  imports: [
    TranslatePipe,
    PaginatorModule,
    ReactiveFormsModule,
    AutocompleteComponent,
    NgIf,
    FullNamePipe
  ],
  templateUrl: './object-resposible.component.html',
  styleUrl: './object-resposible.component.scss'
})
export class ObjectResposibleComponent extends BasicForm<any> implements OnInit {
  @Input() property: Property;

  _defaultService: DefaultService<any> = inject(RentersService);
  modalService = inject(ModalService);
  translate = inject(TranslateService);

  selectedPerson: User = null;
  usersService = inject(UsersService);
  public form = new FormGroup({
    selectedPerson: new FormControl(),
  })
  protected api = inject(ApiService);

  ngOnInit() {
    super.ngOnInit();

    if (this.property.responsibleUserId) {
      this.usersService.getOne(this.property.responsibleUserId).subscribe(
        (data) => {
          this.form.controls.selectedPerson.patchValue(this.property.responsibleUserId);
          this.selectedPerson = data;
        }
      )
    }
  }

  selectPerson(person) {
    this.selectedPerson = person;
  }

  addPerson() {
    this.modalService.open({
      component: RentersFormComponent,
      title: this.translate.instant('PROPERTY.OBJ-DATA'),
      componentOptions: {},
      modalOptions: {
        size: 'lg',
      }
    }).then(value => {
      if (value == ModalClose.SUCCESS) {

      }
    })
  }

  delete() {
    this.api.patch(
      `/v1/buildings/${this.property.id}/responsible-user`,
    ).subscribe(
      () => {
        this.selectedPerson = null
        this.form.patchValue({
          selectedPerson: null
        })
        this.sweetAlertService.success(null, this.translate.instant('MAIN.SUCCESS'));
      },
      error => this.sweetAlertService.error('', error?.error?.message)
    );
  }

  getName(data) {
    if (data) {
      return data.companyName || `${data.firstName} ${data.lastName}` || '-';
    } else {
      return '-';
    }
  }

  updateResponsible() {
    this.api.patch(
      `/v1/buildings/${this.property.id}/responsible-user`,
      {responsible_user_id: this.selectedPerson.id},
    ).subscribe(
      () => {
        this.sweetAlertService.success(null, this.translate.instant('MAIN.SUCCESS'));
      }
    );
  }
}
